export default __webpack_public_path__ + "static/media/control-skin-monkey.14a50f31.png";